import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-platform-feature-redesign',
    templateUrl: './platform-feature-redesign.component.html',
    styleUrls: ['./platform-feature-redesign.component.scss']
})
export class PlatformFeatureRedesignComponent {

    @Input() title = '';

    @Input() image = '';

    @Input() imageAlt = '';

    @Input() paragraphs: string[] = [];

    @Input() imageLeft = true;

    trackByIndex(index: number): number {
        return index;
    }

}